module.exports = __webpack_public_path__ + "static/RemoteTeam.com-e6e7bdcd3aa8721b9129e455dfaacc0a.jpg";